export default "__VITE_ASSET__7dcb3bee__"